import React, { useState, useCallback } from "react";
import { map } from "lodash/fp.js";

import PropTypes from "prop-types";
import { Accordion } from "react-bootstrap";
import AccordionContent from "./AccordionContent.js";
import { AccordionWrapper } from "./AccordionStyles.js";

const CustomAccordion = ({
  elements,
  keyGetter,
  headerComponent: HeaderComponent,
  contentComponent: ContentComponent,
}) => {
  const [currentCard, setCurrentCard] = useState(null);

  const setActiveCard = useCallback(
    (eventKey) => {
      if (eventKey !== currentCard) {
        setCurrentCard(eventKey);
      }
      if (eventKey === currentCard) {
        setCurrentCard(null);
      }
    },
    [currentCard, setActiveCard]
  );

  return (
    <AccordionWrapper>
      <Accordion>
        {map((element) => {
          const key = keyGetter(element);

          return (
            <AccordionContent
              key={key}
              eventKey={key}
              isOpen={currentCard === key}
              setIsOpen={setActiveCard}
              headerComponent={HeaderComponent}
              contentComponent={ContentComponent}
              element={element}
            />
          );
        })(elements)}
      </Accordion>
    </AccordionWrapper>
  );
};

CustomAccordion.propTypes = {
  elements: PropTypes.array.isRequired,
  keyGetter: PropTypes.func.isRequired,
  contentComponent: PropTypes.any.isRequired, // TODO: remove any
  headerComponent: PropTypes.any.isRequired, // TODO: remove any
  showStatusBadge: PropTypes.bool,
};
CustomAccordion.defaultProps = {
  showStatusBadge: false,
  headerComponent: null,
  contentComponent: null,
};

export default CustomAccordion;
